import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/wishlist',
    name: 'wishlist',
    component: () => import('./pages/WishlistPage.vue'),
  },
];
